import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';

export default function CustomizeBackdrop({ open, children, onClose }: any) {
  return (
    <div>
      <Backdrop
        onClick={onClose}
        open={open}
        sx={(theme) => ({
          color: '#fff',
          zIndex: theme.zIndex.drawer + 1,
          backdropFilter: 'blur(7.5px)',
        })}
      >
        {children}
      </Backdrop>
    </div>
  );
}
